import bem from 'utils/bem';

export const block = bem('save-as-template');
